import React, { useEffect, useState } from "react";
import { Row, Col, Button, Container, Card } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { getFinComms } from "../../afinanceapi";
import ReportEmailModal from "./AddEditReportEmail";
import "./Comms.css";

export function ReportEmail({ refresh, onEmailUpdate = () => {} }) {
  const [emailData, setEmailData] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [modalShow, setModalShow] = useState(false);

  const loadEmailData = async () => {
    const token = sessionStorage.getItem("user");
    if (!token) return;
    const decoded = jwtDecode(token);
    const practiceNumbers = decoded.practice || [];
    const normalizedPractices = Array.isArray(practiceNumbers) ? practiceNumbers : [];
    const result = await getFinComms(normalizedPractices);
    setEmailData(Array.isArray(result) ? result : []);
  };

  useEffect(() => {
    loadEmailData();
  }, [refresh]);

  const handleButtonClick = () => {
    setSelectedEmail(emailData.length > 0 ? emailData[0] : null);
    setModalShow(true);
  };

  const getSubject = (entry) =>
    entry?.report?.subject ?? entry?.reportSubject ?? "";
  const getBody = (entry) =>
    entry?.report?.text ?? entry?.reportText ?? "";

  const entry = emailData[0];
  const hasReport = !!(entry && (getSubject(entry) || getBody(entry)));

  return (
    <Container fluid className="border-0">
      <Card className="mb-4 border-0 shadow-sm">
        <Card.Body>
          <div className="d-flex align-items-center mb-3 gap-2 flex-wrap">
            <h6 className="mb-0 text-primary flex-grow-1">Report Email Template</h6>
            <Button variant="primary" className="ms-auto" onClick={handleButtonClick}>
              {hasReport ? "Edit Report Email" : "Add Report Email"}
            </Button>
          </div>

          {!entry ? (
            <Row>
              <Col>
                <div className="text-muted">Loading...</div>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col lg={10} xl={9}>
                <div className="email-template-panel">
                  <div className="mb-3">
                    <div className="fw-semibold">Subject</div>
                    <div className="template-field">
                      {getSubject(entry) || <span className="text-muted">No subject specified</span>}
                    </div>
                  </div>
                  <div className="mb-2 fw-semibold">Email Body</div>
                  <div
                    className="html-preview"
                    dangerouslySetInnerHTML={{
                      __html: getBody(entry) || "<span class='text-muted'>—</span>",
                    }}
                  />
                </div>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      <ReportEmailModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        emailDetail={selectedEmail}
        onSmsUpdate={() => {
          setModalShow(false);
          setSelectedEmail(null);
          loadEmailData();
          onEmailUpdate();
        }}
      />
    </Container>
  );
}
